import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Schema for Restocking flow triggers. `returnId` is the only field consumed:
 * the step processors read only `returnId` from the schema instance, and the
 * Restocking flow editor restricts conditions to a dedicated picker
 * (compensationRestockingFlowOptions) rather than
 * the generic schema-field picker. Everything else is re-derived from the
 * freshly-loaded Return at processing time, so no other field is needed here.
 */
export const restockingFlowSchema = defineSchema({
  fields: {
    returnId: {
      dataType: "Text",
      documentation: "The unique identifier for the return in Redo",
      hideFromConditionStep: true,
      hideFromInsertionModal: true,
    },
  },
});

export const exampleRestockingFlowSchemaInstance: SchemaInstance<
  typeof restockingFlowSchema
> = { returnId: "65b81f41da22f4000718b34e" };
